import { z } from 'zod';

export const settingFeatureFlagSchema = z.object({
  type: z.literal('feature-flags'),
  value: z.object({
    featureFlags: z.array(z.object({
      key: z.string(),
      value: z.boolean()
    }))
  })
});
export type SettingsFeatureFlags = z.infer<typeof settingFeatureFlagSchema>;

export const settingOnboardingSchema = z.object({
  type: z.literal('onboarding'),
  value: z.object({
    completed: z.boolean(),
  })
});
export type SettingsOnboarding = z.infer<typeof settingOnboardingSchema>;

export const settingUserPreferenceSchema = z.object({
  type: z.literal('preferences'),
  value: z.object({
    units: z.enum(['metric', 'imperial']).optional(),
    recipeUnits: z.enum(['metric', 'imperial']).optional()
  }).passthrough()
});
export type SettingsUserPreferences = z.infer<typeof settingUserPreferenceSchema>;

export const settingsDataSchema = z.union([settingFeatureFlagSchema, settingOnboardingSchema, settingUserPreferenceSchema]);
export type Setting = z.infer<typeof settingsDataSchema>;

export type SettingTypeEnum = Setting['type'];

export const settingValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
  z.custom<object>((value) => typeof value === 'object' && value !== null),
]);
export const settingValueMapSchema = z.record(z.string(), settingValueSchema);
export type SettingValueMap = z.infer<typeof settingValueMapSchema>;

export const settingDocSchema = z.object({
  id: z.string(),
  userId: z.string(),
  type: z.enum(['feature-flags', 'onboarding', 'preferences']),
  value: settingValueMapSchema,
  updatedAt: z.string(),
});
export type SettingDocType = z.infer<typeof settingDocSchema>;
